<template>
  <div class="apply">
    <img src="/static/img/tech_apply.png" alt="">

    <div class="btn_box flex_center">
      <button @click="go_techApply()" v-if="is_tech == 0">共享技师申请</button>
      <button @click="go_storeApply()"  v-if="is_store == 0">共享门店申请</button>
      <!-- <button @click="go_techApply()" v-if="is_tech == 1">共享技师申请</button>
      <button @click="go_storeApply()"  v-if="is_store == 1">共享门店申请</button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "apply",
  components: { },
  props:['is_tech','is_store'],
  data() {
    return {
      is_store:0,
      is_tech:0
    }
  },
  created() {
    
    this.is_store = this.$route.query.is_store;
    this.is_tech = this.$route.query.is_tech;

  },
  methods: {
    go_techApply(){
      this.$router.push('/authentication')
    },
    go_storeApply(){
      this.$router.push('/storeApply')
    }
  }
};
</script>
<style scoped>
.btn_box{
  position:absolute;
  bottom:25%;
  width:100%;
  text-align:center;
}
.btn_box button{
  padding:.7rem 1.25rem;
  margin:0 auto;
  background-color:white;
  color:#45B9BC;
  border-radius:5px;
  font-size:.9rem;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/apply.vue